import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiProxyService } from '../../shared/services/api-proxy.service';
import { ExportCriteria } from '../model/export/export-critieria';
import { ExportPreview } from '../model/export/export-preview';
import { ConfigService } from 'app/app-services/config.service';

@Injectable()
export class ExportService {
  constructor(private apiProxy: ApiProxyService, private configService: ConfigService) {  }

  createGlobalExport(exportCritiera: ExportCriteria): Observable<string> {
    return this.apiProxy.post(this.configService.apiUrl + 'export/', exportCritiera);
  }

  createGlobalExportNoCritiera(exportData: number[]): Observable<string> {
    return this.apiProxy.post(this.configService.apiUrl + 'export/noCritiera/' , exportData);
  }

  createGlobalExportPreview(exportCritiera: ExportCriteria): Observable<ExportPreview> {
    return this.apiProxy.post(this.configService.apiUrl + 'export/preview', exportCritiera);
  }

  createGlobalExportPreviewNoCriteria(exportData: number[]): Observable<ExportPreview> {
    return this.apiProxy.post(this.configService.apiUrl + 'export/previewNoCritiera', exportData);
  }
}
